const VERIFICATION_QR_TYPES = new Set(["base45", "encoded"]);

const normalizeQaStatus = (status) =>
  typeof status === "string" ? status.trim().toLowerCase() : "";

const isQaPollingInProgress = (status) =>
  normalizeQaStatus(status) === "in-progress";

export const hasQaPollingInProgress = (recipientList = []) =>
  recipientList.some((recipient) =>
    isQaPollingInProgress(recipient?.qa_status),
  );

export const isVerificationQrType = (type) => VERIFICATION_QR_TYPES.has(type);

export const resolveShouldQaPoll = ({
  isPostIssuanceVerificationEnabled,
  qrType,
  recipients = [],
}) =>
  Boolean(
    isPostIssuanceVerificationEnabled &&
    isVerificationQrType(qrType) &&
    hasQaPollingInProgress(recipients),
  );
